import apiClient from '../../../common/functions/api_axios_instance.function';
import { GET_ONE_RING_GROUP } from '../../../common/constants/constants';

export const getOneRingGroup = async (id) => {
  try {
    const response = await apiClient.get(GET_ONE_RING_GROUP(id));
    return response.data;
  } catch (error) {
    console.error('Error fetching ring group:', error);
    throw error;
  }
};
